import {
  clearReferralClaimPending,
  markReferralClaimPending,
  referralClaimPendingUserId,
} from "../lib/claimPending";

type AccessToken = string | null | undefined;

export async function claimReferral(accessToken: string): Promise<boolean> {
  const response = await fetch("/api/referral/claim", {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!response.ok) {
    throw new Error("Referral claim failed");
  }
  const payload: unknown = await response.json();
  if (!payload || typeof payload !== "object") {
    throw new Error("Referral claim failed");
  }
  return (payload as { claimed?: unknown }).claimed === true;
}

async function runReferralClaim(
  getToken: () => Promise<AccessToken>
): Promise<void> {
  try {
    const token = await getToken();
    if (!token) {
      return;
    }
    await claimReferral(token);
    clearReferralClaimPending();
  } catch {
    // Флаг остаётся. Следующий прогон useUser повторит вызов.
  }
}

export async function finishReferralClaim(
  userId: string,
  getToken: () => Promise<AccessToken>
): Promise<void> {
  markReferralClaimPending(userId);
  await runReferralClaim(getToken);
}

export async function retryReferralClaim(
  userId: string,
  getToken: () => Promise<AccessToken>
): Promise<void> {
  if (referralClaimPendingUserId() !== userId) {
    return;
  }
  await runReferralClaim(getToken);
}
